<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div class="flex-header">
        <student-header [pageTitle]="'Student Digital Content'" [showYearSelector]="false"></student-header>
    </div>
    <div class="flex-content">
        <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="actionsTable" matSortActive="FileName"
            matSortDirection="asc" style="min-width: 1000px;">
            <ng-container matColumnDef="FileName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>File Name</span>
                    <filter #FileNameFilter class="mat-filter" [data]="dataSource" columnName="FileName" dataType="string"
                        #filter></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="height: 100%;">
                    <span>
                        <a (click)="viewFile(element)" class="fileNameLink">
                            {{element.FileName}}
                        </a>
                    </span>                
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Description">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Description</span>
                    <filter #DescriptionFilter class="mat-filter" [data]="dataSource" columnName="Description" dataType="string"
                        #filter></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.Description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="DocumentType">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Document Type</span>
                    <filter #DocumentTypeFilter class="mat-filter" [data]="dataSource" columnName="DocumentType" dataType="string"
                        #filter></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.DocumentType}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="FormAddedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Created By</span>
                    <filter #FormAddedByFilter class="mat-filter" [data]="dataSource" columnName="FormAddedBy" dataType="string"
                        #filter></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.FormAddedBy}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="UploadedDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Created Date</span>
                    <filter #UploadedDateFilter class="mat-filter" [data]="dataSource" columnName="UploadedDate" dataType="date"
                        #filter></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.UploadedDate|date:'MM/dd/yy'}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Actions">
                <mat-header-cell *matHeaderCellDef>
                    <span translate>Actions</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index;">
                    <tyl-mat-menu [topMenuItems]="topActionMenuItems" (menuClick)="actionMenuClick($event)" [data]="element"
                        (click)="$event.stopPropagation()" image="actions.png" [iconWidth]="30">
                    </tyl-mat-menu>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="actionsTableDataRow{{i}}" style="padding:0px;overflow: hidden;">
            </mat-row>
        </mat-table>
    </div>
</tyl-kendo-pdf-export>
<div class="flex-footer">
    <div class="flex-footer-left">
        <tyl-button image="add.png" label="Add Entry" *ngIf="canAddEdit" (clickEvent)="addClick()"></tyl-button>
    </div>
    <div class="flex-footer-middle" style="align-items: center">
        <div style="display:table; margin:0 auto; min-width:100px; height:100%; padding-top:5px;">
            <filter-notification *ngIf="dataSource.isFiltered()" (clearFilter)="clearFilter()" style="padding-top:5px;">
            </filter-notification>
        </div>
    </div>
    <div class="flex-footer-right">

    </div>
</div>
